import { html, strMap } from 'fxjs/es';
import { NessCoreTmplS } from '../../../../../Core/S/Tmpl/module/NessCoreTmplS.js';
import { NessAppPlusHomeTmplS } from './module/NessAppPlusHomeTmplS.js';
import { NessCoreConstantS } from '../../../../../Core/S/Constant/module/NessCoreConstantS.js';
import { UtilImageS } from '../../../../../../Util/Image/S/Function/module/UtilImageS.js';
import { NessAppBrandedContentS } from '../../../../BrandedContent/S/Function/module/NessAppBrandedContentS.js';

const brandedContentItem = (item) => {
  const htmls = NessAppBrandedContentS.makeViewHtmls(item);

  return html`
    <a href="/${ET.lang}/@/brandedcontents/${item.slug}" class="ness-home-brandedcontent__item swiper-slide">
      <div class="ness-home-brandedcontent__item-image">
        <img
          src="${UtilImageS.getResizedUrl({
            url: item.thumbnail_image,
            format: 'webp',
            width: 1280,
          })}"
          alt="branded content thumbnail"
        />
      </div>
      <div class="ness-home-brandedcontent__item-text">
        <h3>${htmls.title}</h3>
        <h4>${htmls.title_en}</h4>
        <p>${htmls.public_at}</p>
      </div>
    </a>
  `;
};

export const brandedContent = (brandedContents, { plus_crew, is_mobile }) => {
  return html`
    <div class="ness-home-brandedcontent__wrapper">
      <div class="ness-home-brandedcontent">
        ${NessAppPlusHomeTmplS.homeTitle({
          title: 'Branded Contents',
          sub_title: ET('ness::home::home_04', { brand: plus_crew.brand_name }),
          title_color: NessCoreConstantS.colors.white,
          sub_title_color: NessCoreConstantS.colors.white,
        })}
        <div class="ness-home-brandedcontent__item-swiper">
          <div class="ness-home-brandedcontent__swiper-container swiper-container">
            <div
              class="ness-home-brandedcontent__items swiper-wrapper"
              data-length="${brandedContents.length}"
            >
              ${strMap(brandedContentItem, brandedContents)}
            </div>
          </div>
          ${is_mobile || brandedContents.length <= 2
            ? ''
            : html`
                <div class="ness-home-brandedcontent__controller">
                  <div class="ness-home-brandedcontent__controller--left swiper-button-disabled">
                    ${NessCoreTmplS.nessLeftIcon({ color: NessCoreConstantS.colors.white })}
                  </div>
                  <div class="ness-home-brandedcontent__controller--right">
                    ${NessCoreTmplS.nessRightIcon({ color: NessCoreConstantS.colors.white })}
                  </div>
                </div>
              `}
        </div>
      </div>
    </div>
  `;
};
